import React from "react";
import SEO from "./SEO";
import BackLink from "./BackLink";
import { company } from "../data/company";
import "./Datenschutz.css";

const Impressum = () => (
  <div className="datenschutz-container">
    <SEO
      title="Impressum | M.F.D. Dienstleistungs GmbH & Co. KG"
      description="Impressum der M.F.D. Dienstleistungs GmbH & Co. KG, Großbeerenstraße 2-10, 12107 Berlin. Angaben gemäß DDG."
      keywords="Impressum, M.F.D. Dienstleistungs GmbH, Berlin, Gebäudereinigung"
      url="https://www.mfd-berlin.com/impressum"
    />
    <BackLink />
    <h1>Impressum</h1>
    <p>Angaben gemäß § 5 DDG</p>

    <h2>Anbieter</h2>
    <p>
      {company.legalName}
      <br />
      {company.street}
      <br />
      {company.postalCode} {company.city}
      <br />
      Deutschland
    </p>

    <h2>Kontakt</h2>
    <p>
      Telefon:{" "}
      <a href={`tel:${company.phones[0].tel}`}>{company.phones[0].display}</a>
      <br />
      Telefon:{" "}
      <a href={`tel:${company.phones[1].tel}`}>{company.phones[1].display}</a>
      <br />
      E-Mail: <a href={`mailto:${company.email}`}>{company.email}</a>
      <br />
      Erreichbarkeit: {company.hoursLabel}
    </p>

    <h2>Registereintrag</h2>
    <p>
      Registergericht: {company.registerCourt}
      <br />
      Registernummer: {company.registerNumber}
    </p>

    <h2>Vertreten durch</h2>
    <p>
      Persönlich haftende Gesellschafterin: {company.partnerName}, Berlin
      <br />
      {company.registerCourt}, {company.partnerRegister}
      <br />
      Geschäftsführerin: {company.directorName}
    </p>

    <h2>Verantwortlich für den Inhalt</h2>
    <p>
      {company.legalName}
      <br />
      {company.street}, {company.postalCode} {company.city}
    </p>
  </div>
);

export default Impressum;
